module.exports = __webpack_public_path__ + "img/beach-size.8bd190f2.svg";